import useIsNative from "@/shared/hooks/useIsNative";
import { useTranslation } from "react-i18next";
import BooleanWithLabel from "../Boolean/BooleanWithLabel";

const NativeNotificationEnabler = () => {
  const { t } = useTranslation("");
  const isNative = useIsNative();
  const onChange = (value) => {
    const customEvent = new CustomEvent("notifications", {
      detail: {
        value,
      },
    });
    window.dispatchEvent(customEvent);
  };
  return false ? (
    <BooleanWithLabel
      checked={false}
      onChange={(e) => onChange(e.target.checked)}
    >
      {t("activeUserNotifications")}
    </BooleanWithLabel>
  ) : undefined;
};

export default NativeNotificationEnabler;
